// PipelineDetailPage — Reforma UX §6.8 / §10.2: o detalhe de pipeline virou
// MODAL sobre a lista. Esta rota (/pipelines/:id) é mantida como DEEP-LINK
// que renderiza a lista (MCPipelinesPage) com a modal de detalhe aberta —
// não quebra links externos. Fechar a modal navega de volta pra /pipelines.
//
// :id aceita id OU slug (getPipeline resolve idOrSlug na modal).

import { useParams } from 'react-router-dom';
import { MCPipelinesPage } from './MCPipelinesPage';

export function PipelineDetailPage() {
  const { id } = useParams<{ id: string }>();
  // key força remount quando o deep-link muda (ex: navegação entre pipelines),
  // re-inicializando o estado da modal na page.
  return <MCPipelinesPage key={id ?? 'none'} deepLinkPipelineId={id ?? null} />;
}
